import {
    Box,
    Button,
    Paper,
    Typography,
    Dialog,
    TextField,
    InputAdornment,
    Grid
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from "react";
import { useConfirm } from 'material-ui-confirm';
import AddActivityComponent from "../components/AddActivityComponent";
import { fetchActivities, deleteActivity, updateActivity, toggleActivityVisibility, validateActivity } from "../api/activities";
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import ActivityCards from "../components/ActivityCards";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import SearchIcon from '@material-ui/icons/Search';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { getCategories } from '../api/categories.js';
import { useAlert } from 'react-alert'

const useStyles = makeStyles((theme) => ({
    modalBox: {
        outline: 0,
        width: '100%',
        position: 'relative',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '1000px',
    },
    modalWrapper: {
        position: 'absolute',
        padding: theme.spacing(1),
        overflow: 'scroll',
        height: '100%',
        width: '100%',
        display: 'block'
    },
    topHeading: {
        display: 'flex',
        margin: theme.spacing(0.5, 0, 2, 0),
        alignItems: 'center',
    }
}));
export default function ActivitiesPage({ providerId, providerCategory, categoryTree, categoryList, providerCategoryTree, providerCategoryList, branches, handleUpdate, user, activitySearchBar, branchID }) {
    const classes = useStyles();
    const confirm = useConfirm();
    const alert = useAlert();
    const [activities, setActivities] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState({})
    const [createModalActive, setCreateModalActive] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState(branchID? branchID: 'template');
    const [query, setQuery] = useState(activitySearchBar);
    const [loading, setLoading] = useState(true);

    // const [categoryList, setCategoryList] = useState([]);
    // const [providerCategoryList, setProviderCategoryList] = useState([]);

    // useEffect(() => {
    //     if (!user) {
    //         return
    //     }
    //     getCategories('Activity_category', user.token)
    //         .then(d => setCategoryList(d.filter(e => e.name!=="Root")))
    //     getCategories('Provider_category', user.token)
    //     .then(d => setProviderCategoryList(d.filter(e => e.isLeaf===true)))

    //     //     .then(() => setLoading(false));
    // }, [user])

    useEffect(() => {
        if (!user || !providerId) {
            return;
        }
        setActivities([])
        setLoading(true)

        fetchActivities(providerId, selectedBranch, user.token, query).then(data => {
            setActivities(data);
            if (selectedBranch === '' && data.length === 0){
                setCreateModalActive(true);
            }
            setLoading(false)
        })
    }, [providerId, user, selectedBranch, query]);

    const handleOpen = () => {
        setCreateModalActive(true);
    };
    const handleEdit = (activity) => () => {
        setSelectedActivity(activity);
        setCreateModalActive(true);
    }
    const handleVisibility = (activity) => () => {
        activity.visibility = !activity.visibility;
        let branchId = 'Template'
        if (activity.hasOwnProperty('branch_id')) {
            branchId = activity.branch_id
        }
        toggleActivityVisibility(providerId, activity._id, branchId, user.token)
        onActivityUpdate(activity)
    }
    const handleDelete = (activity) => () => {
        return confirm({ description: 'This action is permanent!' })
            .then(() => {
                return deleteActivity(providerId, activity, user.token).then(() => {
                    const updatedActivities = [...activities];
                    const index = updatedActivities.findIndex(a => a._id === activity._id);
                    if (index >= 0) {   
                        updatedActivities.splice(index, 1);
                        setActivities(updatedActivities);
                    }
                })
            })
            .catch(() => { console.log('Ignoring delete') })
    }

    const handleValidate = (activity) => () => {
        const validateText = 'Please confirm the action, Once validated, the activity will be ready to be displayed in the app.'
        const invlidateText = 'Please confirm the action, Once invalidated, the activity will not be accessible by the app.'
        const description =  activity.manual_validation_flag ? invlidateText : validateText;
        return confirm({ description })
            .then(() => {
                return validateActivity(
                  providerId,
                  activity._id,
                  activity.branch_id,
                  !activity.manual_validation_flag,
                  user.token
                ).then(() => {
                  setActivities((prev) =>
                    prev.map((item) => {
                      if (item._id === activity._id)
                        return {
                          ...item,
                          manual_validation_flag: !item.manual_validation_flag,
                        };
                      return item;
                    })
                  );
                }).catch(() => {
                    alert.error("Something went wrong, please try again later or contact the support!");
                })
            })
            .catch(() => {
                 console.log('validation cancelled.');
            })
    }

    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        // clearing on close
        setSelectedActivity({});
        setCreateModalActive(false);
    };

    const onActivityUpdate = (activity) => {
        const updatedActivities = [...activities];
        const index = updatedActivities.findIndex(a => a._id === activity._id);
        if (index >= 0) {
            updatedActivities.splice(index, 1, activity);
        } else {
            updatedActivities.unshift(activity)
        }
        setActivities(updatedActivities);
    }


    return (
        <Paper style={{ padding: '2em' }} variant="outlined">
            <Box className={classes.topHeading}>
                <Typography variant="h4" >
                    Activities
                </Typography>
                <Box style={{ 'flex': 1, padding: '0 2em', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Branch</InputLabel>
                        <Select
                            style={{ minWidth: 300 }}
                            labelId="branch-select-label"
                            value={selectedBranch}
                            onChange={(e) => setSelectedBranch(e?.target?.value || 'template')}
                            id="branch-select"
                        >
                            <MenuItem value='template'>Template Activities</MenuItem>
                            {
                                branches.map(branch => (
                                    <MenuItem value={branch.branch_id} id={branch.branch_id}>
                                        {branch.branch_name}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    <TextField
                        id="search"
                        label="Search"
                        variant="outlined"
                        size="small"
                        placeholder="Filter by Name or Id"
                        style={{ marginLeft: 16 }}
                        value={query}
                        onChange={(e) => { setQuery(e.target.value.toLocaleLowerCase()) }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
                <Button variant="contained" color="primary" startIcon={<AddOutlinedIcon />} onClick={handleOpen}>Add Activity</Button>
            </Box>
            {selectedBranch==='template' && 
            <Grid xs={12} spacing={2}>
                <Typography variant="h7" style={{color:"red", fontWeight:"bold"}}> ** Template activities are not linked to any branch. So changes made for an activity which is already linked to a branch will not be reflected unless the changes are made by selecting the right branch in the above branch selector</Typography>
                <br/>
            </Grid>
            }
            <ActivityCards activities={activities}
                handleVisibility={handleVisibility}
                handleDelete={handleDelete}
                handleValidate={handleValidate}
                loading={loading}
                showValidate={user?.roles?.includes('ROLE_VALIDATOR') || user?.roles?.includes('ROLE_ADMIN')}
                handleEdit={handleEdit} />

            <Dialog open={createModalActive} onClose={handleClose} maxWidth="md" fullWidth>
                <AddActivityComponent activity={selectedActivity}
                    onUpdate={onActivityUpdate}
                    providerId={providerId}
                    providerCategory={providerCategory}
                    categoryList={categoryList}
                    providerCategoryList={providerCategoryList}
                    activityCategoryTree={categoryTree}
                    providerCategoryTree={providerCategoryTree}
                    user={user}
                    onCancel={handleClose} />
            </Dialog>
        </Paper>
    );
}
